import {register} from '../vendor/theme-scripts/theme-sections';
import toggleGrid from '../features/collection-grid-toggle';
import accordion from '../features/accordion';
import {swatchGridSection} from '../features/swatch';
import popoutSection from '../features/popout';
import collectionFiltersSidebar from '../features/collection-filters-sidebar';
import collectionFiltersForm from '../features/collection-filters-form';
import {tooltipSection} from '../features/tooltip';
import hideElement from '../util/hide-element';

var selectors = {
  sort: '[data-sort-enabled]',
  sortLinks: '[data-sort-link]',
  sortValue: 'data-value',
  collectionNavGrouped: '[data-tag-group]',
  linkAdd: '.link--add',
  linkRemove: '.link--remove',
};

class Collection {
  constructor(section) {
    this.container = section.container;
    this.sort = this.container.querySelector(selectors.sort);
    this.sortLinks = this.container.querySelectorAll(selectors.sortLinks);
    this.init();
  }

  init() {
    if (this.sort) {
      this.initClick();
    }
    this.removeUnusableFilters();
  }

  removeUnusableFilters() {
    // temp tag filters
    const collectionNavGrouped = this.container.querySelectorAll(selectors.collectionNavGrouped);
    if (collectionNavGrouped.length > 0) {
      collectionNavGrouped.forEach((element) => {
        const linkAdd = element.querySelector(selectors.linkAdd);
        const linkRemove = element.querySelector(selectors.linkRemove);

        if (!linkAdd && !linkRemove) {
          hideElement(element);
        }
      });
    }
  }

  onClick(e) {
    const sort = e.currentTarget.getAttribute(selectors.sortValue);
    const url = new window.URL(window.location.href);
    const params = url.searchParams;
    params.set('sort_by', sort);
    url.search = params.toString();
    window.location.replace(url.toString());
  }

  initClick() {
    this.sortLinks.forEach((link) => {
      link.addEventListener(
        'click',
        function (e) {
          this.onClick(e);
        }.bind(this)
      );
    });
  }
}

const collectionSection = {
  onLoad() {
    this.collection = new Collection(this);
  },
};

register('collection', [collectionSection, popoutSection, collectionFiltersSidebar, collectionFiltersForm, toggleGrid, swatchGridSection, tooltipSection, accordion]);
